module.exports = __webpack_public_path__ + "static/media/check_ok.58b4c8cf.png";